import {
    createLoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { mountComponent } from '../util/mount';
import {
    AppId,
    HtmlId,
} from '../enums/elementId';

/**
 * Create Brix Loading Spinner component.
 *
 * @param id - Wrapper ID of the element.
 * @param isNested - Place the loading spinner
 * as a nested child element inside a block/parent container.
 * @returns Loading Spinner component or
 * null if the element with the given ID is not found.
 */
export const mountLoadingSpinner = (id: HtmlId, isNested = false) =>
    mountComponent(id, createLoadingSpinner, {
        optNested: isNested,
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

/**
 * Set the visibility of the Loading Spinner component.
 *
 * @param spinner - Brix component to show or hide.
 * @param isVisible - Show/hide the component.
 */
export const setLoadingSpinnerVisibility = (spinner: LoadingSpinner | null, isVisible: boolean) => {
    if (!spinner) {
        return;
    }

    spinner.toggle(isVisible);
    spinner.toggleContainer(!isVisible);
};

/**
 * Creates loading spinner element for overlay
 */
export const createLoadingSpinnerElement = () => {
    const loadingSpinner = document.createElement('div');
    loadingSpinner.setAttribute('id', AppId.OVERLAY_LOADING);
    loadingSpinner.classList.add(AppId.OVERLAY_LOADING, 'ws10-is-hidden');

    return loadingSpinner;
};
